import { render, staticRenderFns } from "./EstadoPago.vue?vue&type=template&id=28ab57a3"
import script from "./EstadoPago.vue?vue&type=script&lang=js"
export * from "./EstadoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports